
import React from 'react'
import { Divider} from "antd";
import TableHelper from "../../components/TableHelper";
import PageWrap from '../../components/PageWrap';
import { fetchAccountingRecordList } from '../../services/accountingRecord';
import { mapAccountingRecordDataRange, mapAccountingRecordStatus } from '../../axios/dictionaries';
import {findDict, formatTime, isPlatform} from '../../utils';
import AccountingRecordUpdate from './update';
import AuthButton from '../../components/AuthButton/AuthButton';
import AccountingRecordDetail from './detail';
import AccoungingRecordProcessActions from './components/ProcessActions';
import AccoungingRecordFlowListModal from './components/FlowListModal';
import MerchantConfirmProcessModal from './components/MerchantConfirmProcessModal';
/**
 * @Author: zhao - 🍉
 * @Date: 2021-12-17 14:08:09
 * @LastEditTime: 2021-12-22 10:48:00
 * @LastEditors: zhao - 🍉
 * @Description: 商户对账
 * @FilePath: /zhzj-admin/src/page/AccountingRecord/inedx.jsx
 */
class AccountingRecord extends React.Component{

    handleEdit = (id) => {
        this.AccountingRecordUpdateRef.open(id).then(() => {
            this.TableHelperRef.postDataSource()
        })
    }

    processActionChange = () => {
        this.TableHelperRef.postDataSource()
    }

    handleDetail = (id,loan) => {
        this.AccountingRecordDetailRef.open(id,loan)
    }

    handleFlow = (id) => {
        this.AccoungingRecordFlowListModalRef.open(id)
    }
    
    handleMerchantConfirmProcess = (id) => {
        
        this.MerchantConfirmProcessModal.open(id).then(res => {
           this.processActionChange()
        })
    }

  

    render(){

        

        const columns = [
            { title: '商户', dataIndex: 'merchantShortName' },
            { title: '所属年月', dataIndex: '_date', render: (text, record) => {
                return  record.year	+ '-' + record.month	
            } },
            
            { title: '汇集期数', dataIndex: 'collectionPeriod' },
            { title: '结余总额', dataIndex: 'balanceTotal' },
            { title: '开始日期', dataIndex: 'startDate', render: (text) => formatTime(text, 'YYYY-MM-DD') },
            { title: '结束日期', dataIndex: 'endDate', render: (text) => formatTime(text, 'YYYY-MM-DD') },
            { title: '状态', dataIndex: 'status', render: (text) => {
                return findDict(mapAccountingRecordStatus,text).title
            } },
            { title: '创建人', dataIndex: 'createByName' },
            { title: '创建时间', dataIndex: 'createTime', render: formatTime },
            { title: '操作', dataIndex: 'action', width:260,  render: (_,records) => {
                return (
                    <React.Fragment>
                        {records.update && (
                            <AuthButton authkey="e-11-1">
                            <a onClick={() => this.handleEdit(records.id)}>编辑</a>
                            <Divider type="vertical" />
                        </AuthButton>
                        )}
                        {!records.update && (
                        <AuthButton authkey="e-11-2">
                            <a onClick={() => this.handleDetail(records.id,records.loan)}>详情</a>
                            <Divider type="vertical" />
                        </AuthButton>)}

                        <AuthButton authkey="e-11-3">
                            <a onClick={() => this.handleFlow(records.id)}>对账审批流程列表</a>
                            <Divider type="vertical" />
                        </AuthButton>
                        {
                            records.confirm && (
                        <AuthButton authkey="e-11-6">
                            <a onClick={() => this.handleMerchantConfirmProcess(records.id)} >确认流程</a>
                            <Divider type="vertical" />
                        </AuthButton>)
                        }
                        {isPlatform()?(
                        <AccoungingRecordProcessActions records={records} onChange={this.processActionChange} />
                       ):null}
                    </React.Fragment>
                )
            } }
        ]
        const searchOptions = [
            { key: 'createTimeStart', type: 'date', placeholder: '请选择创建开始日期',width:150, },
            { key: 'createTimeEnd', type: 'date', placeholder: '请选择创建截止日期',width:150 },
            {key: 'status', type: 'select', placeholder: '状态', options: mapAccountingRecordStatus},
            {key: 'shortName', type: 'input', placeholder: '商户简称'},
        ]
        return (
            <PageWrap >
                <TableHelper 
                    ref={ref => this.TableHelperRef = ref}
                    columns={columns}
                    searchOptions={searchOptions}
                    request={fetchAccountingRecordList}
                >
                <div slot="search">
                    <AuthButton authkey="g-1-2" type="primary" icon="plus" onClick={() =>this.handleEdit()}>新增</AuthButton>
                </div>
                </TableHelper>
                <AccountingRecordUpdate wrappedComponentRef={ref => { this.AccountingRecordUpdateRef = ref }} />
                <AccountingRecordDetail ref={ref => { this.AccountingRecordDetailRef = ref }} />
                <AccoungingRecordFlowListModal ref={ref => { this.AccoungingRecordFlowListModalRef = ref }} />
                <MerchantConfirmProcessModal ref={ref => this.MerchantConfirmProcessModal = ref} />
              
            </PageWrap>
        )
    }
}

export default AccountingRecord


// WEBPACK FOOTER //
// ./src/page/AccountingRecord/inedx.jsx